module.exports = __webpack_public_path__ + "static/media/insta1.e0bc1146.jpg";